import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BezeichnungDtoServiceConfig = {
  name: "BezeichnungDto",
  annotations: []
} as ServiceConfig;